const fonts = {
  title: '"Ubuntu", sans-serif',
  text: '"Open Sans", sans-serif',
};

export default fonts;
